module.exports = __webpack_public_path__ + "static/media/infoDocs.fad29f13.svg";